<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="app" :class="vueAppClasses" class="gradient-background">
        <navbar class="white-background" />
        <router-view></router-view>
    </div>
</template>

<script>
import Navbar from './views/navbar/Navbar'
import themeConfig from '@/../themeConfig.js'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            vueAppClasses: [],
            intervalId: null
        }
    },
    components: {
        Navbar
    },
    watch: {
        '$store.state.theme'(val) {
            this.toggleClassInBody(val)
        },
        '$vs.rtl'(val) {
            document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
        },
        'authenticated'(authed) {
            if (!this.preventRedirect) {
                this.$router.replace({ path: '/' })
            }

            if (authed) {
                this.pollEditions()
            } else {
                clearInterval(this.intervalId)
                this.intervalId = null
            }
            // this.$router.go()
        }
    },
    computed: {
        ...mapGetters({
            preventRedirect: 'auth/preventRedirect',
            currentUser: 'auth/current_user'
        })
    },
    methods: {
        toggleClassInBody(className) {
            if (className == 'dark') {
                if (document.body.className.match('theme-semi-dark'))
                    document.body.classList.remove('theme-semi-dark')
                document.body.classList.add('theme-dark')
            } else if (className == 'semi-dark') {
                if (document.body.className.match('theme-dark'))
                    document.body.classList.remove('theme-dark')
                document.body.classList.add('theme-semi-dark')
            } else {
                if (document.body.className.match('theme-dark'))
                    document.body.classList.remove('theme-dark')
                if (document.body.className.match('theme-semi-dark'))
                    document.body.classList.remove('theme-semi-dark')
            }
        },
        setAppClasses(classesStr) {
            this.vueAppClasses.push(classesStr)
        },
        handleWindowResize() {
            this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

            // Set --vh property
            document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
        },
        handleScroll() {
            this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
        },
        pollEditions() {
            if (this.currentUser && this.currentUser.roles.any((x) => x == 'Content_Creator')) {
                if (!this.intervalId) {
                    this.intervalId = setInterval(() => {
                        this.$store.dispatch('auth/fetchEdition')
                    }, 5000)
                }
            } else {
                clearInterval(this.intervalId)
                this.intervalId = null
            }
        }
    },
    mounted() {
        this.toggleClassInBody(themeConfig.theme)
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

        let vh = window.innerHeight * 0.01
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        this.pollEditions()
    },
    async created() {
        let dir = this.$vs.rtl ? 'rtl' : 'ltr'
        document.documentElement.setAttribute('dir', dir)

        window.addEventListener('resize', this.handleWindowResize)
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowResize)
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
<style scoped>
.gradient-background {
    background: linear-gradient(180deg, #cce9d7, #8fcec5);
}
.white-background {
    background: white;
}
</style>
